// Запоминание данных клиента между сессиями/страницами, чтобы бронь и формы
// предзаполнялись — как «last_phone» на сайтах Солнышка, плюс ФИО и email.
// Храним отформатированный телефон ("+7 ... ...") — PhoneInput при монтировании
// сам покажет нужный префикс страны без доп. парсинга.

export type ClientData = {
  phone?: string;
  last_name?: string;
  first_name?: string;
  patronymic?: string;
  email?: string;
};

const COOKIE_NAME = "ap_client";
const MAX_AGE_DAYS = 90;

export function readClientCookie(): ClientData {
  if (typeof document === "undefined") return {};
  const m = document.cookie.match(new RegExp("(?:^|; )" + COOKIE_NAME + "=([^;]*)"));
  if (!m) return {};
  try {
    const v = JSON.parse(decodeURIComponent(m[1]));
    return v && typeof v === "object" ? (v as ClientData) : {};
  } catch {
    return {};
  }
}

// Мёржим переданные поля в существующие (частичное обновление), пустые не пишем.
export function writeClientCookie(patch: ClientData): void {
  if (typeof document === "undefined") return;
  const cur = readClientCookie();
  const next: ClientData = { ...cur };
  for (const k of Object.keys(patch) as (keyof ClientData)[]) {
    const val = (patch[k] || "").trim();
    if (val) next[k] = val;
  }
  const maxAge = MAX_AGE_DAYS * 24 * 60 * 60;
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(JSON.stringify(next))}; path=/; max-age=${maxAge}; SameSite=Lax`;
}

// Совместимость с логикой Солнышка (телефон отдельным помощником).
export function readPhoneCookie(): string {
  return readClientCookie().phone || "";
}
export function writePhoneCookie(value: string): void {
  writeClientCookie({ phone: value });
}
